import React, { useEffect, useRef } from "react";
import * as _ from "underscore";

import UndoButton from "web_modules/Messages/UndoButton";

import MessageDisplay from "./MessageDisplay";

const styles = require("./styles.module.scss");

interface MessageConversationProps {
  appID: number;
  messages: any;
  pendingMessages: any;
  deletePendingMessage?: Function;
  markMessageAsRead?: Function;
}

const MessageConversation: React.SFC<MessageConversationProps> = ({
  appID,
  messages,
  pendingMessages,
  deletePendingMessage,
  markMessageAsRead,
}) => {
  const messagesList = useRef(null);

  useEffect(() => {
    // Scroll to bottom after new messages
    messagesList.current.scrollTop = messagesList.current.scrollHeight;
  }, [messages, pendingMessages]);

  const renderPendingMessages = () => {
    const pendingMsgsObj = _.mapObject(pendingMessages, (val, key) => (
      <MessageDisplay appID={appID} message={{ ...val, sender_type: "operator" }} key={key}>
        <UndoButton handleOnClick={deletePendingMessage.bind(this, key)} />
      </MessageDisplay>
    ));
    return _.values(pendingMsgsObj);
  };

  return (
    <ul className={styles.messagesList} ref={messagesList}>
      {messages.map((message, i) => (
        <MessageDisplay appID={appID} message={message} key={i} markRead={markMessageAsRead} />
      ))}
      {renderPendingMessages()}
    </ul>
  );
};

export default MessageConversation;
